import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUserRolesSearchText = createSelector(
  [(store: RootState) => store.locationShow.userRolesSearchText],
  (searchText) => searchText
);
